import { Product } from 'src/app/models/core/product.model';

type SellerSold = Pick<Product, 'total_tickets_by_seller'>;

const FULL_PERCENTAGE = 100;
const MIN_VISIBLE_SHARE = 1;

/**
 * Tickets que vendió el vendedor de este producto (lo que muestra "N vendidas").
 * La API lo manda como string ("61"): se normaliza con Number, si no `+` concatena al sumar.
 */
export function getSellerSoldCount(product: SellerSold): number {
  return Number(product.total_tickets_by_seller) || 0;
}

/** Total de ventas de un conjunto de productos (el denominador de "% del total"). */
export function sumSellerSold(products: readonly SellerSold[]): number {
  return products.reduce((total, product) => total + getSellerSoldCount(product), 0);
}

/**
 * Qué parte del total representan `sold` ventas, como entero entre 1 y 100.
 * Devuelve null (la fila no muestra porcentaje) sin total (`<= 0`, evita "NaN%") y sin
 * ventas (`sold <= 0`, evita "0% del total"). Con al menos una venta el mínimo es 1%:
 * 1 venta de 300 no se redondea a "0%".
 */
export function getSoldShare(sold: number, total: number): number | null {
  if (total <= 0 || sold <= 0) return null;
  const rounded = Math.round(Math.min(FULL_PERCENTAGE, (sold / total) * FULL_PERCENTAGE));
  return Math.max(MIN_VISIBLE_SHARE, rounded);
}
